// Utils
import { normalisePath } from '../normalisePath';
/**
 * @description Returns an object with a single property found in `obj` at `path`
 *
 * @param {Record<string, any>} obj The object that contains the property we want to return
 * @param {string} path Path to the property
 * @returns {Record<string, any>} Property found in `obj` at `path`
 *
 * @example
 * getPropertyAtPath({a: {x:1}, b: {y: 5, z: 6} }, 'b')
 * // returns {b: {y: 5, z: 6}}
 *
 */
export var getPropertyAtPath = function (obj, path) {
    var pathArray = normalisePath("" + path);
    var defaultObject = {};
    var currentItem = obj;
    pathArray.reduce(function (acc, key, i) {
        if (!(key in currentItem))
            return acc;
        currentItem = currentItem[key];
        if (acc[key] === undefined) {
            Array.isArray(currentItem) ? (acc[key] = []) : (acc[key] = {});
        }
        if (i === pathArray.length - 1)
            acc[key] = currentItem;
        return acc[key];
    }, defaultObject);
    return defaultObject;
};
//# sourceMappingURL=getPropertyAtPath.js.map